package devxertech.com.pages.services.devOperation.devLifeCycles

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun DevOpsLifeCycle() {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

    val spanModifier = Modifier
        .fontFamily(Constants.ROBOTO_FONT)
        .fontSize(if (breakpoint == Breakpoint.LG) 30.px else if (breakpoint < Breakpoint.LG) 20.px else 35.px)
        .fontWeight(FontWeight.ExtraBold)
        .lineHeight(if (breakpoint >= Breakpoint.LG) 37.4.px else 30.px)
        .letterSpacing(0.5.px)
        .textTransform(TextTransform.Uppercase)
        .padding(bottom = if (breakpoint > Breakpoint.MD) 5.px else 0.px)

    Column(
        modifier = Modifier.fillMaxWidth().margin(top = if (breakpoint > Breakpoint.MD) 20.px else 0.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SpanText(text = "THE LIFE CYCLE OF DEVOPS", modifier = Modifier
            .fontFamily(Constants.FONT_FAMILY)
            .fontSize(if (breakpoint > Breakpoint.MD) 22.px else 16.px)
            .color(sitePalette.commonSecondaryButtonColor.rgb)
            .fontWeight(FontWeight.Medium)
            .lineHeight(18.4.px)
            .textTransform(TextTransform.Uppercase)
            .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else 10.px)
        )
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Row(modifier = Modifier.flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center,
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(text = "The Continuous Loop Of ",
                    modifier = spanModifier.color(sitePalette.commonSecondaryButtonColor.rgb))
                SpanText(text = "DevOps Enables The",
                    modifier = spanModifier.color(sitePalette.commonSecondaryButtonColor.rgb))
                SpanText(text = " Ultimate",
                    modifier = spanModifier.color(sitePalette.primary.rgb))
            }
            SpanText(text = "Software Sustainability",
                modifier = spanModifier.color(sitePalette.primary.rgb)
                    .textAlign(TextAlign.Center))
        }
    }
    Box(modifier = Modifier.fillMaxWidth().margin(top = if(breakpoint > Breakpoint.MD) (-30).px else 0.px),
        contentAlignment = Alignment.Center) {
        Image(src = Res.Image.devOps, description = "DevOps lifecycle diagram", modifier = Modifier
            .fillMaxWidth(if(window.screen.width > 475) 63.percent else 90.percent)
        )
    }
}
